<template>
  <OrTooltipV3>
    <OrIconV3 icon="info" />
    <template #content>
      <div class="w-[400px]">
        {{ text }}
      </div>
    </template>
  </OrTooltipV3>
</template>
<script lang="ts">

import { OrIconV3, OrTooltipV3 } from '@onereach/ui-components';
import { defineComponent } from 'vue';


export default defineComponent({
  name: 'CustomTooltip',
  components: {
    OrIconV3,
    OrTooltipV3,
  },
  props: {
    text: {
      type: String,
      required: true,
    },
  },
});
</script>
